module.exports = __webpack_public_path__ + "static/media/Mockup.b1d7ccb6.png";